import React, { Component } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import {
  Section,
  SectionHeader,
  BoxDiscover,
  BoxLayoutMobileSingle,
  WayPointHandler,
  BlogSlider,
} from 'components';
import './Culture.scss';
import { data, sliderData } from './logic';

class Culture extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMobile: false,
    };
  }

  componentDidMount() {
    this.handleResize();

    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth < 768 });
  };

  renderBoxes = loadedData => {
    const { isMobile } = this.state;

    return data.map((item, index) => (
      <BoxDiscover
        headline={item.headline}
        description={item.description}
        background={loadedData[item.image].childImageSharp.fluid}
        additionalClass={`culture__box ${
          isMobile ? '' : 'anim-fade-in-bottom'
        }`}
        key={`box-culture-${index}`}
        color={item.color}
        link={item.link}
        externalLink
        id={`box-culture-${index}`}
      />
    ));
  };

  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            frontClub: file(relativePath: { eq: "culture/front.png" }) {
              childImageSharp {
                fluid(maxWidth: 300) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            holacracyMeetup: file(
              relativePath: { eq: "culture/holaman.png" }
            ) {
              childImageSharp {
                fluid(maxWidth: 300) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            ctoAsks: file(relativePath: { eq: "culture/cto.png" }) {
              childImageSharp {
                fluid(maxWidth: 300) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            tealSpaceSlider: file(
              relativePath: { eq: "culture/teal-space.png" }
            ) {
              childImageSharp {
                fluid(maxWidth: 1300) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            holaSlider: file(relativePath: { eq: "culture/meetup.jpg" }) {
              childImageSharp {
                fluid(maxWidth: 1900) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `}
        render={loadedData => (
          <WayPointHandler path={'culture'}>
            <>
              <Section color={'gray-light'} additionalClass={'culture'}>
                <SectionHeader
                  lineColor={'yellow'}
                  description={
                    'Life at Boldare is about knowledge-sharing and sharing cake, teamwork and team fun, openness and open bar, accountability and the ability to play guitar, JavaScript pro and PlayStation pro, holacracy and friendly ¡Hola!. Together it all makes us Boldare!'
                  }
                >
                  Culture
                </SectionHeader>
              </Section>
              <BlogSlider
                data={sliderData.map(slide => ({
                  ...slide,
                  background:
                    loadedData[slide.background].childImageSharp.fluid,
                }))}
              />
              <Section color={'gray-light'}>
                <SectionHeader size={'medium'}>
                  Sharing knowledge
                </SectionHeader>
                <BoxLayoutMobileSingle mobileSlider>
                  {this.renderBoxes(loadedData)}
                </BoxLayoutMobileSingle>
              </Section>
            </>
          </WayPointHandler>
        )}
      />
    );
  }
}

export default Culture;
